import { useState, useEffect } from "react";

// Custom sorting function
const customSort = (a, b) => {
  // Check if 'product' property exists in both objects
  const hasProductA = a.hasOwnProperty('AWSProduct');
  const hasProductB = b.hasOwnProperty('AWSProduct');

  // If both elements have 'product' property, maintain their order
  if (hasProductA && hasProductB) {
    return 0;
  }

  // If only 'a' has 'product' property, move 'a' to a lower index
  if (hasProductA && !hasProductB) {
    return -1;
  }

  // If only 'b' has 'product' property, move 'b' to a higher index
  if (!hasProductA && hasProductB) {
    return 1;
  }

  // If neither 'a' nor 'b' has 'product' property, maintain their order
  return 0;
};


function useHooks() {
  const [products, setProducts] = useState([]);

  async function GetProducts() {
    try {
      const data = await fetch("https://zmkjks441a.execute-api.eu-west-1.amazonaws.com/default/FetchProducts", {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const jsondata = await data.json();
      // const updatedData = jsondata.map(item => ({
      //   ...item,
      //   productImage: "https://construirewebsiteproducts.s3.eu-west-1.amazonaws.com/WebsiteImages/Free-hd-blurred-wallpaper.jpg"
      // }));

      // Sort the flatdata array using the custom sorting function
      const sortedProd = jsondata.sort(customSort);

      console.log("products fetched from dynamoDB:", sortedProd);
      setProducts(sortedProd);

    } catch (error) {
      console.log(error);
      throw error; // Rethrow error to handle it outside
    }
  }

  useEffect(() => {
    GetProducts();
  }, [])

  return products;
}


export const Productdata = () => {
  
  const prod = useHooks();

  return prod;
};
